import React from 'react';
import '../../CSS/Slider.css';
import room1 from '../../images/slidercarousel/room1.jpg';
import room2 from '../../images/slidercarousel/room2.jpg';
import room3 from '../../images/slidercarousel/room3.jpg';
import room4 from '../../images/slidercarousel/room4.jpg';
import room5 from '../../images/slidercarousel/room5.jpg';


const SliderCarousel = () => {
    return (
    <>
    <section id="slider">
        <input type="radio" name="slider" id="s1" checked />
        <input type="radio" name="slider" id="s2" checked />
        <input type="radio" name="slider" id="s3" checked />
        <input type="radio" name="slider" id="s4" checked />
        <input type="radio" name="slider" id="s5" checked />

        <label for="s1" id="slide1"><img src={room1} style={{ width: "100%", height: "100%" }} alt="room1" /></label>
        <label for="s2" id="slide2"><img src={room2} style={{ width: "100%", height: "100%" }} alt="room2" /></label>
        <label for="s3" id="slide3"><img src={room3} style={{ width: "100%", height: "100%" }} alt="room3" /></label>
        <label for="s4" id="slide4"><img src={room4} style={{ width: "100%", height: "100%" }} alt="room4" /></label>
        <label for="s5" id="slide5"><img src={room5} style={{ width: "100%", height: "100%" }} alt="room5" /></label>

        <label for="s1" id="slide1">Couple Room</label>
        <label for="s2" id="slide2">Deluxe Room</label>
        <label for="s3" id="slide3">Presidential Suite</label>
        <label for="s4" id="slide4">Suite</label>
        <label for="s5" id="slide5">Double Bed</label>
    </section>
    </>
    )
};

export default SliderCarousel;